module.exports = __webpack_public_path__ + "static/assets/d00ebbc2cedcaa3856c0652479cd2bc0.png";